import network from '@/utils/network'

/**
 * récupère tout les changelogs
 */
export const fetchAllChangelog = async () => {
  const r = await network.get('/version/changelog')
  return r.data
}
/**
 * Poste un changelog
 * @returns {Promise<>}
 */
export const postChangelog = async (changelog) => {
  const r = await network.post(`/admin/version/changelog`, { ...changelog })
  return r.data
}
